import { filter, map } from 'ramda'
import { func } from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import React, { useMemo, useState } from 'react'

import routes, { getPagePath } from 'config/routes'

import useStyles from '../styles'

const HeaderNav = ({ setIsMenuOpen }) => {
  const classes = useStyles()
  const location = useLocation().pathname
  const [activeLink, setActiveLink] = useState(location)

  useMemo(() => {
    setActiveLink(location)
  }, [location])

  const pageList = filter(page => page.isOnMainNav, routes)

  const handleMenuItemClick = page => {
    setActiveLink(page.path)
    setIsMenuOpen(false)
  }

  return (
    <nav className={classes.navigation} id="nav">
      {map(
        page => (
          <Link
            key={page.id}
            to={getPagePath(page.id)}
            className={classNames(classes.navLink, {
              [classes.isActive]: activeLink === page.path,
              [classes.isDisabled]: page.isDisabled,
            })}
            onClick={() => handleMenuItemClick(page)}
          >
            {page.pageName}
          </Link>
        ),
        pageList,
      )}
    </nav>
  )
}

HeaderNav.propTypes = {
  setIsMenuOpen: func,
}

HeaderNav.defaultProps = {
  setIsMenuOpen: Function.prototype,
}

export default HeaderNav
